var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3067(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.969,
    height: 36,
    viewBox: "0 0 36.969 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3067",
    "data-name": "Group 3067",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69800",
    "data-name": "Path 69800",
    d: "M1755.969,203.17l-2.336,9.642,16.715,6.007.027-.01v1.7l-.027-.01-17.382,6.248-.562-1.335.574-2.5c.055-.18.06-.189.272-.249,4.617-1.183,7.539-4.57,1.382-5.767-.247-.053-.265-.062-.21-.3l.384-1.679-2.37-.851-.3-.11c-.342-.142-.354-.167-.279-.487l.082-.334,2.313-9.521Z",
    transform: "translate(-1751.814 -190.742)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69801",
    "data-name": "Path 69801",
    d: "M1786.9,186.821V173.772a9.584,9.584,0,0,0-1.776-.99,17.84,17.84,0,0,0-2.428-.834,29.23,29.23,0,0,0-5.724-.913l-2.82,11.953a36.156,36.156,0,0,1,7.117,1.412,30.583,30.583,0,0,1,5.63,2.426m.667,0V173.772a9.536,9.536,0,0,1,1.775-.99,17.841,17.841,0,0,1,2.428-.834,29.228,29.228,0,0,1,5.724-.913l2.82,11.953a36.149,36.149,0,0,0-7.117,1.412,30.578,30.578,0,0,0-5.627,2.421Zm-12.862-14.167L1772,184.472l15.087,5.316a.566.566,0,0,0,.32,0l15.087-5.316-2.72-11.818-1.24-.511-.347-1.455a.524.524,0,0,0-.567-.4,30.053,30.053,0,0,0-6.139.98,14.111,14.111,0,0,0-4.233,1.836,13.838,13.838,0,0,0-4.233-1.836,30.052,30.052,0,0,0-6.139-.98.524.524,0,0,0-.567.4l-.347,1.455Z",
    transform: "translate(-1768.631 -163.342)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69802",
    "data-name": "Path 69802",
    d: "M1876.554,203.17l2.336,9.642-16.715,6.007-.025-.01v1.7l.025-.01,17.383,6.248.564-1.335-.574-2.5c-.057-.18-.06-.189-.274-.249-4.615-1.183-7.539-4.57-1.38-5.767.247-.053.265-.062.21-.3l-.384-1.679,2.37-.851.3-.11c.334-.142.354-.167.277-.487l-.08-.334-2.313-9.521Z",
    transform: "translate(-1843.738 -190.742)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69803",
    "data-name": "Path 69803",
    d: "M1815.139,186.318a28.245,28.245,0,0,0-3.94-1.392,16.626,16.626,0,0,0-3.69-.6l.085-.4a17.171,17.171,0,0,1,3.71.612,28.592,28.592,0,0,1,3.838,1.347Z",
    transform: "translate(-1798.215 -174.705)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69804",
    "data-name": "Path 69804",
    d: "M1813.1,197.856a29.452,29.452,0,0,0-4.267-1.5,17.436,17.436,0,0,0-3.7-.6l.085-.4a18.018,18.018,0,0,1,3.721.611,29.821,29.821,0,0,1,4.172,1.452Z",
    transform: "translate(-1796.232 -184.228)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69805",
    "data-name": "Path 69805",
    d: "M1810.913,210.536a33.237,33.237,0,0,0-4.6-1.5,20.567,20.567,0,0,0-3.743-.592l.083-.4a21.105,21.105,0,0,1,3.754.6,33.7,33.7,0,0,1,4.526,1.47Z",
    transform: "translate(-1794.102 -194.8)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69806",
    "data-name": "Path 69806",
    d: "M1808.577,223.552a35.215,35.215,0,0,0-4.858-1.615,21.653,21.653,0,0,0-3.88-.634l.084-.4a22.214,22.214,0,0,1,3.893.641,35.407,35.407,0,0,1,4.772,1.575Z",
    transform: "translate(-1791.826 -205.514)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69807",
    "data-name": "Path 69807",
    d: "M1806.233,236.852a38.919,38.919,0,0,0-5.055-1.669,24.358,24.358,0,0,0-4.078-.7l.083-.4a25.019,25.019,0,0,1,4.093.708,39.049,39.049,0,0,1,4.966,1.629Z",
    transform: "translate(-1789.545 -216.495)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69808",
    "data-name": "Path 69808",
    d: "M1872.975,186.318a28.277,28.277,0,0,1,3.938-1.392,16.655,16.655,0,0,1,3.689-.6l-.083-.4a17.186,17.186,0,0,0-3.711.612,28.675,28.675,0,0,0-3.838,1.347Z",
    transform: "translate(-1852.752 -174.705)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69809",
    "data-name": "Path 69809",
    d: "M1873.335,197.856a29.55,29.55,0,0,1,4.268-1.5,17.44,17.44,0,0,1,3.7-.6l-.083-.4a18.022,18.022,0,0,0-3.721.611,29.811,29.811,0,0,0-4.172,1.452Z",
    transform: "translate(-1853.051 -184.228)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69810",
    "data-name": "Path 69810",
    d: "M1873.642,210.495a33.248,33.248,0,0,1,4.609-1.51,20.521,20.521,0,0,1,3.743-.592l-.083-.4a21.14,21.14,0,0,0-3.756.6,33.688,33.688,0,0,0-4.524,1.47Z",
    transform: "translate(-1853.303 -194.758)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69811",
    "data-name": "Path 69811",
    d: "M1874.012,223.552a35.043,35.043,0,0,1,4.858-1.615,21.653,21.653,0,0,1,3.88-.634l-.083-.4a22.221,22.221,0,0,0-3.895.641,35.374,35.374,0,0,0-4.771,1.575Z",
    transform: "translate(-1853.611 -205.514)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69812",
    "data-name": "Path 69812",
    d: "M1874.382,236.852a38.829,38.829,0,0,1,5.054-1.669,24.349,24.349,0,0,1,4.077-.7l-.083-.4a25,25,0,0,0-4.092.708,39.17,39.17,0,0,0-4.968,1.629Z",
    transform: "translate(-1853.922 -216.495)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69813",
    "data-name": "Path 69813",
    d: "M1849.2,133.451a3.711,3.711,0,1,1-4.616-4.754.046.046,0,0,1,.057.022.048.048,0,0,1-.008.06,3.222,3.222,0,1,0,4.485,4.622.05.05,0,0,1,.062-.008.047.047,0,0,1,.02.058",
    transform: "translate(-1826.934 -128.694)",
    fill: "#cf2969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69814",
    "data-name": "Path 69814",
    d: "M1861.9,136.278l.974.093a.047.047,0,0,1,.042.033.048.048,0,0,1-.015.052l-.733.649.212.956a.049.049,0,0,1-.018.05.05.05,0,0,1-.055,0l-.834-.5-.844.5a.049.049,0,0,1-.053,0,.047.047,0,0,1-.018-.05l.212-.956-.734-.649a.047.047,0,0,1-.013-.052.045.045,0,0,1,.042-.033l.974-.093.391-.9a.05.05,0,0,1,.045-.028.05.05,0,0,1,.045.028Z",
    transform: "translate(-1841.969 -134.24)",
    fill: "#cf2969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3067);
export default __webpack_public_path__ + "static/media/Group 3067.b6ec5ede8b7ae68baf139671a3199370.svg";
export { ForwardRef as ReactComponent };